export enum ManagedPolicyKind {
  SCHOOL = 'school',
  HOME = 'home'
}
export enum ManagedPolicyStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published'
}
export enum ManagedAction {
  ALLOW = 'allow',
  BLOCK = 'block'
}
export enum ParentGrantStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REVOKED = 'revoked'
}
export enum SettingsRequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  PROPOSED = 'proposed',
  COMMITTED = 'committed',
  REJECTED = 'rejected'
}
export enum SafetyAppealStatus {
  UPHOLD = 'uphold_block',
  ALLOW = 'allow_scoped_access',
  REVIEW = 'needs_human_review'
}
export enum ManagedYearFilter {
  ALL = 'all',
  UNASSIGNED = 'unassigned'
}

export enum ManagedBlockingConflictCode {
  SCHOOL_TRANSFER_RECOVERY = 'managed_school_transfer_recovery',
  PARENT_ALREADY_ACCEPTED = 'managed_parent_already_accepted',
  ASSIGNMENT_EXISTS = 'managed_assignment_exists'
}
export enum ManagedCategoryGroupId {
  SAFETY = 'safety',
  CONTENT = 'content',
  WORKAROUNDS = 'workarounds',
  OTHER = 'other'
}
export enum ManagedCategoryPresetId {
  SCHOOL = 'school',
  FOCUS = 'focus'
}
export enum ManagedSchoolTab {
  SCHEDULES = 'schedules',
  STUDENTS = 'students',
  PARENTS = 'parents',
  ACTIVITY = 'activity'
}
export enum ManagedScheduleState {
  UNPUBLISHED = 'unpublished',
  LIVE = 'live',
  LIVE_WITH_CHANGES = 'live_with_changes'
}
export enum ManagedWeekTone {
  SCHOOL = 'school',
  HOME = 'home'
}
export enum ManagedChecklistStepId {
  CREATE = 'create',
  PUBLISH = 'publish',
  ASSIGN = 'assign',
  PARENTS = 'parents'
}
export enum ManagedAppPlatform {
  MACOS = 'macos',
  WINDOWS = 'windows',
  ANDROID = 'android',
  IOS = 'ios'
}
export enum ManagedViolationKind {
  WEBSITE = 'website',
  APP = 'app'
}
export enum ManagedAppDecision {
  ALLOW = 'allow',
  BLOCK = 'block'
}
